import { postFn } from '../lib/axiosActions';

export const ADD_TUTORIAL_START = 'ADD_TUTORIAL_START';
export const ADD_TUTORIAL_SUCCESS = 'ADD_TUTORIAL_SUCCESS';
export const ADD_TUTORIAL_ERROR = 'ADD_TUTORIAL_ERROR';

const _post = postFn(ADD_TUTORIAL_START, ADD_TUTORIAL_SUCCESS, ADD_TUTORIAL_ERROR);

export const add = tutorial => _post('/users/profile/tutorialId', { tutorialId: `cv.${tutorial}` }, {}, tutorial);
